<div class="card">
  <app-header
    titulo="Datasets"
    descricao="Repositórios de dados de referência usados para complementar os registros de um processo">
  </app-header>

  <div class="surface-50 border-1 surface-border border-round p-3 mb-4 line-height-3">
    Um dataset funciona como uma tabela de consulta, por exemplo uma lista de códigos e descrições. Crie o dataset, escolha os campos que identificam cada registro
    e depois carregue os dados por uma etapa <strong>Dataset</strong> em um <a routerLink="/smartinteg/processos">processo</a>.
  </div>

  <p-toolbar styleClass="mb-4">
    <ng-template pTemplate="left">
      <p-button label="Novo Dataset" icon="pi pi-plus" severity="success" (onClick)="novoDataset()"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table [value]="datasets" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="descricao">Descrição <p-sortIcon field="descricao"></p-sortIcon></th>
        <th>Campos chave</th>
        <th pSortableColumn="qtdRegistros" style="width: 10rem">Registros <p-sortIcon field="qtdRegistros"></p-sortIcon></th>
        <th pSortableColumn="criadoEm" style="width: 12rem">Criado em <p-sortIcon field="criadoEm"></p-sortIcon></th>
        <th style="width: 11rem">Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-dataset>
      <tr>
        <td><strong>{{ dataset.nome }}</strong></td>
        <td>{{ dataset.descricao }}</td>
        <td>
          <div class="chips-chave">
            <p-tag *ngFor="let c of dataset.camposChave" [value]="c" severity="info"></p-tag>
          </div>
        </td>
        <td>{{ dataset.qtdRegistros | number }}</td>
        <td>{{ dataset.criadoEm | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <button pButton pRipple icon="pi pi-table" label="Ver dados" class="p-button-info p-button-text" [attr.aria-label]="'Ver dados de ' + dataset.nome" (click)="verDados(dataset)"></button>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text" pTooltip="Editar" [attr.aria-label]="'Editar ' + dataset.nome" tooltipPosition="top" (click)="editarDataset(dataset)"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" pTooltip="Excluir" [attr.aria-label]="'Excluir ' + dataset.nome" tooltipPosition="top" (click)="deletarDataset(dataset)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center p-4">Nenhum dataset cadastrado. Crie um dataset e carregue os dados por um recurso do tipo DATASET.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Dialog de Adicionar/Editar Dataset -->
<p-dialog
  [(visible)]="datasetDialog"
  [style]="{width: '600px'}"
  [breakpoints]="{'640px': '96vw'}"
  [header]="isEditDialog ? 'Editar Dataset' : 'Novo Dataset'"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">
  <ng-template pTemplate="content">
    <div class="p-fluid grid conteudo-dialog" [formGroup]="form">
      <div class="col-12 form-section-heading first-section">
        <h3>1. Identificação</h3>
        <p>Escolha um nome que descreva os dados de referência que serão armazenados.</p>
      </div>
      <div class="field col-12">
        <p-floatLabel>
          <input
            pInputText
            id="nome"
            formControlName="nome"
            [class.ng-invalid]="campoInvalido('nome')"
            [class.ng-dirty]="campoInvalido('nome')"
          />
          <label for="nome">Nome do Dataset *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('nome')">
          Nome é obrigatório (mínimo 3 caracteres)
        </small>
        <small class="dica">Ex.: Tabela de municípios.</small>
      </div>

      <div class="field col-12">
        <p-floatLabel>
          <textarea pInputTextarea id="descricao" formControlName="descricao" rows="3"></textarea>
          <label for="descricao">Descrição</label>
        </p-floatLabel>
      </div>

      <div class="col-12 form-section-heading">
        <h3>2. Identificação dos registros</h3>
        <p>Os campos chave permitem encontrar cada registro e cruzá-lo com os dados do processo.</p>
      </div>
      <div class="field col-12">
        <label for="camposChave" class="block mb-2">Campos chave *</label>
        <p-chips
          inputId="camposChave"
          formControlName="camposChave"
          styleClass="w-full"
          [addOnBlur]="true"
          [allowDuplicate]="false"
          placeholder="Digite o nome do campo e pressione Enter"
          (onAdd)="normalizarChaves()">
        </p-chips>
        <small class="p-error" *ngIf="campoInvalido('camposChave')">
          Informe ao menos um campo chave
        </small>
        <small class="dica">
          Digite um campo e pressione Enter para adicioná-lo. Esses campos devem existir nos dados carregados e identificar cada registro.
          Use os mesmos nomes na etapa Dataset que fará a carga. Eles serão convertidos para maiúsculas.
        </small>
        <div class="aviso-chaves p-inline-message p-inline-message-warn" *ngIf="chavesAlteradas">
          <span class="p-inline-message-icon pi pi-exclamation-triangle"></span>
          <span class="p-inline-message-text">
            Alterar os campos chave não recalcula as chaves dos registros já gravados. Faça uma nova carga (full refresh) para regravá-los.
          </span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" [disabled]="salvando" (click)="fecharDialog()"></button>
    <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-success" [loading]="salvando" (click)="salvarDataset()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog de Dados do Dataset -->
<p-dialog
  [(visible)]="dadosDialog"
  [style]="{width: '90vw', maxWidth: '1300px'}"
  [breakpoints]="{'640px': '96vw'}"
  [header]="'Dados - ' + (datasetDados?.nome ?? '')"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="fecharDados()">
  <ng-template pTemplate="content">
    <div class="filtro-dados">
      <input
        pInputText
        id="filtroChave"
        placeholder="Filtrar pelo início da chave (chave composta separada por |)"
        [(ngModel)]="filtroChave"
        (keyup.enter)="pesquisar()"
      />
      <button pButton pRipple label="Filtrar" icon="pi pi-search" (click)="pesquisar()"></button>
      <button pButton pRipple label="Limpar" icon="pi pi-filter-slash" class="p-button-text" [disabled]="!filtroChave" (click)="limparFiltro()"></button>
    </div>

    <p-table
      [value]="registros"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [paginator]="true"
      [rows]="linhasPorPagina"
      [first]="primeiraLinha"
      [totalRecords]="totalRegistros"
      [loading]="carregandoDados"
      [rowsPerPageOptions]="[20, 50, 100, 500]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
      [scrollable]="true"
      scrollHeight="28rem"
      styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th style="min-width: 10rem">Chave</th>
          <th *ngFor="let c of colunas" style="min-width: 9rem">{{ c }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-registro>
        <tr>
          <td class="celula-chave">{{ registro.chave }}</td>
          <td *ngFor="let c of colunas" [class.celula-chave]="ehChave(c)">{{ valorCelula(registro.dados[c]) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="colunas.length + 1" class="text-center p-4">
            {{ filtroChave ? 'Nenhum registro encontrado para o filtro informado.' : 'Este dataset ainda não tem dados. Eles são gravados pela carga de um recurso do tipo DATASET.' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Fechar" icon="pi pi-times" class="p-button-text" (click)="fecharDados()"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
